<div id="transaction-details-section">
    <span id="subtitle">Standing authorization details</span>
    <a *ngIf="(createRequestStep$ | async) === 'review' && !isInrFromTable" id="edit-link" class="no-print" (click)="onEditClicked()">Edit</a>

    <!-- TRANSACTION TYPE -->
    <mm-label-group id="reviewPage_transactionTypeLabel" data-testid="reviewPage_transactionTypeLabel"
      [title]="labels.transactionType" [data]="transactionType" ></mm-label-group>

      <!-- TRANSFER DIRECTION -->
    <div class="row">
      <mm-label-group id="reviewPage_transferDirectionLabel" [title]="labels.transferDirection"
        [data]="transferDirection | titlecase"></mm-label-group>
    </div>

    <!-- SOURCE OF FUNDS/ACCOUNT TO RECEIVE FUNDS -->
    <div class="row">
      <mm-label-group id="reviewPage_sourceOfFundsLabel"
        [title]="isAchIn ? labels.sourceOfFunds : labels.accountToReceiveFunds"
        [multilineData]="[to1, accountName, to2, accountType, abaNumber]"></mm-label-group>
    </div>

    <!-- FREQUENCY/RECURRING FREQUENCY -->
    <div class="row" *ngIf="!!frequency && isRecurring; else oneTime">
      <div class="col">
        <mm-label-group id="reviewPage_frequency.recurring" [title]="labels.frequency" [data]="frequencyTypes.recurring"
          data-testid="reviewPage_frequency.recurring"></mm-label-group>
      </div>
      <div class="col">
        <mm-label-group id="reviewPage_frequencyOfOccurrenceLabel" [title]="labels.frequencyDescription"
          [data]="frequency" data-testid="reviewPage_frequencyOfOccurrence"></mm-label-group>
      </div>
      <div class="col" id="spacer_column_secondCompletionDateLabel" data-testid="spacer_column_secondCompletionDate" *ngIf="secondCompletionDate"></div>
      <div class="col" id="spacer_column_endDateLabel" data-testid="spacer_column_endDate" *ngIf="endDate"></div>
      <div class="col" id="spacer_column_fundsAvailableToTradeDateLabel" data-testid="spacer_column_fundsAvailableToTradeDate" *ngIf="isRecurring && transferDirection === 'incoming' && (createRequestStep$ | async) !== 'view'"></div>
    </div>

    <!-- ONETIME FREQUENCY -->
    <ng-template #oneTime>
      <div class="row">
        <div class="col">
          <mm-label-group id="reviewPage_frequency.onetime" [title]="labels.frequency" [data]="frequencyTypes.onetime"
            data-testid="reviewPage_frequency.onetime"></mm-label-group>
        </div>
      </div>
    </ng-template>

    <!-- DATES SECTION -->
    <div class="row">
      <div class="col" *ngIf="isRecurring">
        <!-- NEXT WITHDRAWAL DATE -->
        <mm-label-group id="reviewPage_nextExpectedWithdrawalDateLabel" data-testid="reviewPage_nextExpectedWithdrawalDate" [title]="labels.nextExpectedWithdrawalDate"
          [data]="(nextWithdrawalDate | date : 'MM/dd/yyyy')!"></mm-label-group>
        <div class="label-group">
          <span id="reviewPage_completionDateCopy">{{withdrawalDateCopy}}</span>
        </div>
      </div>

      <!-- NEXT COMPLETION DATE -->
      <div class="col" *ngIf="isRecurring">
        <mm-label-group id="reviewPage_nextCompletionDateLabel" data-testid="reviewPage_nextCompletionDate" [title]="labels.nextCompletionDate" [data]="
            (nextCompletionDate ? (nextCompletionDate | date : 'MM/dd/yyyy') : '')!"></mm-label-group>
      </div>

      <!-- SECOND COMPLETION DATE -->
      <div class="col" *ngIf="secondCompletionDate">
        <mm-label-group id="reviewPage_secondCompletionDateLabel" data-testid="reviewPage_secondCompletionDate" [title]="labels.secondCompletionDate"
          [data]="(secondCompletionDate | date : 'MM/dd/yyyy')!"></mm-label-group>
      </div>

      <!-- END DATE -->
      <div class="col" *ngIf="endDate">
        <mm-label-group id="reviewPage_endDate" data-testid="reviewPage_endDate" [title]="labels.endDate" [data]="(endDate ? (endDate | date : 'MM/dd/yyyy') : '')!"></mm-label-group>
      </div>

      <!-- FUNDS AVAILABLE TO TRADE -->
      <div *ngIf="isRecurring && transferDirection === 'incoming' && (createRequestStep$ | async) !== 'view'" class="col">
        <mm-label-group id="reviewPage_fundsAvailableToTradeLabel" data-testid="reviewPage_fundsAvailableToTrade"
          [title]="labels.fundsAvailableToTrade"
          [data]="(fundsAvailableToTrade ? (fundsAvailableToTrade | date : 'MM/dd/yyyy') : 'N/A')!"></mm-label-group>
        <div class="label-group">
          <span id="reviewPage_fundsAvailableToTradeCopy">{{fundsAvailableToTradeCopy}}</span>
        </div>
      </div>
    </div>

    <ng-template [ngIf]="!isIra || (isIra && transferDirection === 'incoming')">
    <div class="row">
      <div class="col">
        <mm-label-group *ngIf="isRecurring" id="reviewPage_amountLabel" data-testid="reviewPage_amount" [title]="labels.amount"
        [data]="amount"></mm-label-group>
      </div>
    </div>
  </ng-template>

    <ng-template [ngIf]="isIra && transferDirection === 'outgoing'">
      <div class="row">
        <div class="small-col">
          <!-- GROSS AMOUNT -->
        <mm-label-group *ngIf="isRecurring" id="reviewPage_grossAmountLabel" data-testid="reviewPage_grossAmount" 
          [title]="labels.amount" [data]="grossAmount"></mm-label-group>
          
          <!-- FED TAX PERCENT -->
          <mm-label-group id="reviewPage_federalTaxLabel" [title]="labels.federalTax"
            [data]="fedTaxPercent"></mm-label-group>
  
            <!-- STATE TAX PERCENT -->
          <mm-label-group id="reviewPage_stateTaxLabel" [title]="saStateTaxLabel"
            [data]="stateTaxPercent"></mm-label-group>
  
        </div>
        <div class="small-col">
          <!-- AMOUNT TYPE - GROSS/NET -->        
           <mm-label-group *ngIf="!isNra" id="reviewPage_AmountTypeLabel" data-testid="reviewPage_amountType" 
            [title]="labels.grossNet" [data]="amountType | titlecase"></mm-label-group>
           <!-- FED TAX AMOUNT -->
           <mm-label-group *ngIf="!isNra && isRecurring" id="reviewPage_federalTaxAmountLabel" data-testid="reviewPage_federalTaxAmount"
             [title]="labels.federalTaxAmount" [data]="fedTaxAmount"></mm-label-group>
      
            <!-- STATE TAX AMOUNT -->
            <mm-label-group *ngIf="!isNra && isRecurring" id="reviewPage_stateTaxAmountLabel" data-testid="reviewPage_stateTaxAmount"
             [title]="labels.stateTaxAmount" [data]="stateTaxAmount"></mm-label-group>
      
            <!-- NET CASH AMOUNT -->
            <mm-label-group *ngIf="isRecurring" id="reviewPage_netAmountLabel" data-testid="reviewPage_netAmount" [title]="labels.netCashAmount"
             [data]="netAmount"></mm-label-group>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="isIra">
      <div class="row">
        <div class="col">
          <div *ngIf="transferDirection === 'incoming'">
            <!-- CONTRIBUTION REASON -->
            <mm-label-group id="reviewPage_contributionReasonLabel" [title]="labels.contributionReason"
              [data]="contributionReason"></mm-label-group>
          </div>
          <div *ngIf="transferDirection === 'outgoing'">
            <!-- DISTRIBUTION REASON -->
            <mm-label-group id="reviewPage_distributionReasonLabel" [title]="labels.distributionReason"
              [data]="distributionReason"></mm-label-group>
          </div>
        </div>
      </div>
    </ng-template>

    <div *ngIf="!!nickname">
      <!-- AUTHORIZATION NICKNAME -->
      <mm-label-group id="standingAuthAchDetails_authorizationNickname"
      data-testid="standingAuthAchDetails_authorizationNickname" [title]="labels.authorizationNickname"
      [data]="nickname"></mm-label-group>
    </div>

    <ng-template [ngIf]="isIra">
      <!-- TAX PARAGRAPH ONE -->
      <div class="row" *ngIf="transferDirection === 'outgoing'">
        <div class="label-group" data-testid="review_Page_taxParagraphOne"
          *ngIf="(createRequestStep$ | async) === 'review'">
          <span id="tax-copy-paragraph-one">{{taxCopyParagraphOne}}</span>
        </div>
      </div>
      <!-- TAX PARAGRAPH TWO -->
      <div class="row" *ngIf="transferDirection === 'outgoing'">
        <div class="label-group" data-testid="checkDetails_taxParagraphTwo"
          *ngIf="(createRequestStep$ | async) === 'review'">
          <span id="tax-copy-paragraph-two">{{taxCopyParagraphTwo}}</span>
        </div>
      </div>
    </ng-template>
    <sdps-divider variation="secondary"></sdps-divider>
  </div>
